import axios from "axios";
import { ip, answerRoute } from "./config";

export async function getAnswer(answer, words) {
  return axios.post(ip + answerRoute, { animal: answer, words }).then((res) => res.data);
}
